import React, { lazy } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';
import Loadable from '../ui-component/Loadable';

// project imports
import MinimalLayout from './../layout/MinimalLayout';

const AuthLogin = Loadable(lazy(() => import('../views/authentication/session/Login')));
// Self-service registration temporarily hidden again (2026-08-15) — see the matching comment
// in the backend's auth.route.js for why. Register.js/RegisterForm.js are otherwise fixed and
// ready; re-enabling just needs this import and the route below restored.
// const AuthRegister = Loadable(lazy(() => import('../views/authentication/session/Register')));
const VerifyEmail = Loadable(lazy(() => import('../views/authentication/verify-email')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/forgot-password')));
const ResetPassword = Loadable(lazy(() => import('../views/authentication/reset-password')));

//-----------------------|| AUTHENTICATION ROUTING ||-----------------------//

const AuthenticationRoutes = () => {
    const location = useLocation();

    return (
        <Route path={['/session/login', '/session/register', '/verify-email', '/forgot-password', '/reset-password']}>
            <MinimalLayout>
                <Switch location={location} key={location.pathname}>
                    <Route path='/session/login' component={AuthLogin} />
                    <Route path='/session/register'><Redirect to='/session/login' /></Route>
                    <Route path='/verify-email' component={VerifyEmail} />
                    <Route path='/forgot-password' component={ForgotPassword} />
                    <Route path='/reset-password' component={ResetPassword} />
                </Switch>
            </MinimalLayout>
        </Route>
    );
};

export default AuthenticationRoutes;
